/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * BETREIBER 13.09.2026: „Kartenauswahl zeigt, WO der Banner angezeigt
 * wird. Ggf. liegen zwei Banner uebereinander mit unterschiedlichen
 * Seitenzuordnungen."
 * 
 *   ALLE    — auf jeder Karte (so war es bisher).
 *   ZUFALL  — auf EINER Karte, zufaellig gewaehlt, je Aufruf neu.
 *   AUSWAHL — nur auf den Karten aus `karten`.
 * 
 * WOFUER: Kopf- und Fussbereich werden EINMAL eingerichtet und stehen
 * auf allen Karten. Zwei Baender uebereinander — eines fuer die
 * Startkarte, eines fuers Spiel — brauchten bisher einen Anzeigefilter
 * ueber den Seitennamen. Das ist dieselbe Sache, nur als Einstellung
 * statt als Regel.
 * 
 * NUR IM KOPF- UND FUSSBEREICH SINNVOLL: Ein Baustein, der AUF einer
 * Karte liegt, ist ohnehin nur dort.
 * @export
 */
export const DatabaseBannerKarten = {
    Alle: 'ALLE',
    Zufall: 'ZUFALL',
    Auswahl: 'AUSWAHL'
} as const;
export type DatabaseBannerKarten = typeof DatabaseBannerKarten[keyof typeof DatabaseBannerKarten];


export function DatabaseBannerKartenFromJSON(json: any): DatabaseBannerKarten {
    return DatabaseBannerKartenFromJSONTyped(json, false);
}

export function DatabaseBannerKartenFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseBannerKarten {
    return json as DatabaseBannerKarten;
}

export function DatabaseBannerKartenToJSON(value?: DatabaseBannerKarten | null): any {
    return value as any;
}

